export const initialProfileDetails = {
    token:'',
    userMessage:'',
    sideBarOpen: false,
    isTenant: false,
    welcomeOverlayShown: false,
    isProspectUser: false,
    tokenIssuedAt: null as number | null,
    tokenExpiresAt: null as number | null,
}